import styled from 'styled-components';

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 25px 60px;
  margin: 0 auto;
  text-align: center;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 45px 80px 60px;
  }
`;

const ContentHeader = styled.div`
  ${(props) => props.theme.font.heading.v100};
  font-weight: ${(props) => props.theme.font.weight.v300};
  text-transform: uppercase;
  padding: 15px 0;
`;

const ContentBody = styled.div`
  ${(props) => props.theme.font.body.v200};
  font-weight: ${(props) => props.theme.font.weight.v100};
  color: ${(props) => props.theme.color.neutral.v500};

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.body.v300};
  }
`;

const CancelPaymentButton = styled.button`
  color: ${(props) => props.theme.color.neutral.v100};
  ${(props) => props.theme.font.detail.v200};
  font-weight: ${(props) => props.theme.font.weight.v300};
  width: 240px;
  margin-top: 30px;
  padding: 20px 0;
  text-align: center;
  border: none;
  background-color: ${(props) => props.theme.color.primary.v200};
  border-radius: ${(props) => props.theme.border.radius};
  text-transform: uppercase;
  cursor: pointer;
  &:hover,
  &:focus {
    outline-color: ${(props) => props.theme.color.primary.v300};
    background-color: ${(props) => props.theme.color.primary.v300};
  }
`;

export { ModalContentWrapper, ContentHeader, ContentBody, CancelPaymentButton };
